// extracted by mini-css-extract-plugin
export var askAiIcon = "_pe-9";
export var container = "_pe-0";
export var groupSeparator = "_pe-a";
export var highlight = "_pe-4";
export var resultIcon = "_pe-5";
export var resultItem = "_pe-7";
export var resultSubtitle = "_pe-3";
export var resultTitle = "_pe-2";
export var resultsList = "_pe-1";
export var searchGroup = "_pe-6";
export var selected = "_pe-8";